/*
 *
 * RouteHeader
 *
 * @version 1.0.0
 * @author Stefano Servodidio
 * @since 26-Nov-2024
 */

import RouteHeader from './RouteHeader'

export default RouteHeader
